export { NgxLoadingModule } from './ngx-loading.module';
export { NgxLoadingConfig } from './ngx-loading.config';
